import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentEmails(enrollmentId: number): Promise<string[]> {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getEnrollmentEmails.url, { id: enrollmentId }))
    .get<string[]>()
}
